import React, { useState } from "react";

const YTVideo = ({ id, title }) => (
  <div className="video-wrapper">
    <div className="ratio ratio-16x9">
      <iframe
        src={`https://www.youtube.com/embed/${id}`}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </div>
  </div>
);

const Section = ({ heading, videos }) => (
  <div className="previous-summit-group">
    <div className="row">
      <div className="col-12">
        <div className="section-title">
          <h2 style={{ color: "#fe0606" }}>{heading}</h2>
        </div>
      </div>
    </div>
    <div className="row g-4">
      {videos.map((v, idx) => (
        <div className="col-lg-4 col-md-6 col-12" key={`${v.id}-${idx}`}>
          <div className="previous-summit-video">
            <YTVideo id={v.id} title={v.title} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

const PreviousSummitsSection = () => {
  const [activeYear, setActiveYear] = useState("2025");
  const videos2025 = [
    { id: "Hm2NYshEANs", title: "Cash Flow Summit 2025 - Video 1" },
    { id: "KpgY8EsGE9U", title: "Cash Flow Summit 2025 - Video 2" },
    { id: "lBnr__mHW10", title: "Cash Flow Summit 2025 - Video 3" },
    { id: "Vd5qqQEwALQ", title: "Cash Flow Summit 2025 - Video 4" },
    { id: "SLdskW10EGE", title: "Cash Flow Summit 2025 - Video 5" },
    { id: "Rpauz6dBnpM", title: "Cash Flow Summit 2025 - Video 6" },
  ];

  const videos2024 = [
    { id: "iES3HZxrtoA", title: "Cash Flow Summit 2024 - Video 1" },
    { id: "jgvm0wE_dMQ", title: "Cash Flow Summit 2024 - Video 2" },
    { id: "NIVlFL0oQ7I", title: "Cash Flow Summit 2024 - Video 3" },
    { id: "jT8lbgfPIxs", title: "Cash Flow Summit 2024 - Video 4" },
    { id: "YBGyjsLlds8", title: "Cash Flow Summit 2024 - Video 5" },
    { id: "9N0vgZ4vMFg", title: "Cash Flow Summit 2024 - Video 6" },
  ];

  return (
    <section className="previous-summits section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-title text-center">
              <h2>Our Previous Summit Feedback</h2>
            </div>
          </div>
        </div>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <button
            type="button"
            onClick={() => setActiveYear("2025")}
            style={{
              padding: "12px 20px",
              marginRight: 8,
              borderRadius: 8,
              border: "none",
              cursor: "pointer",
              background: activeYear === "2025" ? "#252686" : "#e9ecef",
              color: activeYear === "2025" ? "#fff" : "#111",
              fontWeight: 700,
              fontSize: 18,
              minWidth: 120,
            }}
          >
            2025
          </button>
          <button
            type="button"
            onClick={() => setActiveYear("2024")}
            style={{
              padding: "12px 20px",
              borderRadius: 8,
              border: "none",
              cursor: "pointer",
              background: activeYear === "2024" ? "#252686" : "#e9ecef",
              color: activeYear === "2024" ? "#fff" : "#111",
              fontWeight: 700,
              fontSize: 18,
              minWidth: 120,
            }}
          >
            2024
          </button>
        </div>
        {activeYear === "2025" ? (
          <Section heading="Cash Flow Summit 2025" videos={videos2025} />
        ) : (
          <Section heading="Cash Flow Summit 2024" videos={videos2024} />
        )}
      </div>
    </section>
  );
};

export default PreviousSummitsSection;
